// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Spaces from "../theme/Spaces.res.js";
import * as FontSizes from "../theme/FontSizes.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
let styles = {
  root: {
    "font-kVVagm": "font-xyeg6z0",
    "letterSpacing-kb6lSQ": "letterSpacing-x1owzkzt",
    "whiteSpace-khDVqt": "whiteSpace-x1fj9vlw",
    "overflowWrap-kHjlTd": "overflowWrap-xj0a0fe",
    $$css: "wino-gc:src/resources/typography/TextStyle.res.js:10"
  },
  neutralView: {
    "color-kMwMTN": "color-xbp64b2",
    $$css: "wino-gc:src/resources/typography/TextStyle.res.js:16"
  },
  normalView: {
    "color-kMwMTN": "color-x1qqs05d",
    $$css: "wino-gc:src/resources/typography/TextStyle.res.js:19"
  },
  successView: {
    "color-kMwMTN": "color-x19yl8he",
    $$css: "wino-gc:src/resources/typography/TextStyle.res.js:22"
  },
  negativeView: {
    "color-kMwMTN": "color-x1dxcrjc",
    $$css: "wino-gc:src/resources/typography/TextStyle.res.js:25"
  },
  importantView: {
    "color-kMwMTN": "color-xztrgot",
    $$css: "wino-gc:src/resources/typography/TextStyle.res.js:28"
  },
  warningView: {
    "color-kMwMTN": "color-xq64rm1",
    $$css: "wino-gc:src/resources/typography/TextStyle.res.js:31"
  },
  primaryView: {
    "color-kMwMTN": "color-x1lewwgq",
    $$css: "wino-gc:src/resources/typography/TextStyle.res.js:34"
  },
  secondaryView: {
    "color-kMwMTN": "color-x1mx85f4",
    $$css: "wino-gc:src/resources/typography/TextStyle.res.js:37"
  },
  placeholderView: {
    "color-kMwMTN": "color-x14lhq51",
    $$css: "wino-gc:src/resources/typography/TextStyle.res.js:40"
  },
  subduedView: {
    "color-kMwMTN": "color-x1qqs05d",
    "fontStyle-kKX8nH": "fontStyle-x1k4tb9n",
    $$css: "wino-gc:src/resources/typography/TextStyle.res.js:43"
  },
  alignLeft: {
    "textAlign-k9WMMc": "textAlign-xdpxx8g",
    $$css: "wino-gc:src/resources/typography/TextStyle.res.js:47"
  },
  alignCenter: {
    "textAlign-k9WMMc": "textAlign-x2b8uid",
    $$css: "wino-gc:src/resources/typography/TextStyle.res.js:50"
  },
  alignRight: {
    "textAlign-k9WMMc": "textAlign-x1hr2gdg",
    $$css: "wino-gc:src/resources/typography/TextStyle.res.js:53"
  }
};
function weightFromParams(weight) {
  if (weight === "medium") {
    return {
      fontWeight: 500
    };
  } else if (weight === "regular") {
    return {
      fontWeight: 400
    };
  } else if (weight === "strong") {
    return {
      fontWeight: 700
    };
  } else {
    return {
      fontWeight: 600
    };
  }
}
function lineHeightFromParams(lineHeight, fontSize) {
  if (lineHeight !== undefined) {
    return {
      lineHeight: Spaces.toPx(lineHeight),
      display: "inline-block"
    };
  } else if (fontSize === "xsmall" || fontSize === "xxsmall" || fontSize === "xtiny" || fontSize === "tiny") {
    return {
      lineHeight: "16px"
    };
  } else if (fontSize === "large") {
    return {
      lineHeight: "20px"
    };
  } else if (fontSize === "normal" || fontSize === "small") {
    return {
      lineHeight: "18px"
    };
  } else {
    return {};
  }
}
function alignFromParams(align) {
  if (align === "start") {
    return styles.alignLeft;
  } else if (align === "center") {
    return styles.alignCenter;
  } else {
    return styles.alignRight;
  }
}
function baseStyleFromParams(variation, underlined, strikethrough, italic, maxLines, wrap, direction) {
  return [styles.root, typeof variation === "object" ? {
    color: variation.VAL
  } : variation === "secondary" ? styles.secondaryView : variation === "important" ? styles.importantView : variation === "neutral" ? styles.neutralView : variation === "primary" ? styles.primaryView : variation === "warning" ? styles.warningView : variation === "subdued" ? styles.subduedView : variation === "normal" ? styles.normalView : variation === "success" ? styles.successView : variation === "placeholder" ? styles.placeholderView : styles.negativeView, underlined ? {
    textDecorationLine: "underline"
  } : {}, strikethrough ? {
    textDecorationLine: "line-through"
  } : {}, italic ? {
    fontStyle: "italic",
    paddingRight: "1px"
  } : {}, wrap ? {} : {
    whiteSpace: "nowrap"
  }, maxLines !== undefined ? maxLines !== 0 && maxLines !== 1 ? {
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: String(maxLines),
    display: "-webkit-box",
    overflow: "hidden"
  } : {
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    direction: direction,
    display: "block",
    overflow: "hidden"
  } : {}];
}
function TextStyle(props) {
  let __opacity = props.opacity;
  let __direction = props.direction;
  let __wrap = props.wrap;
  let __italic = props.italic;
  let __strikethrough = props.strikethrough;
  let __underlined = props.underlined;
  let __size = props.size;
  let __weight = props.weight;
  let __variation = props.variation;
  let __align = props.align;
  let align = __align !== undefined ? __align : "start";
  let variation = __variation !== undefined ? __variation : "neutral";
  let weight = __weight !== undefined ? __weight : "regular";
  let size = __size !== undefined ? __size : "normal";
  let underlined = __underlined !== undefined ? __underlined : false;
  let strikethrough = __strikethrough !== undefined ? __strikethrough : false;
  let italic = __italic !== undefined ? __italic : false;
  let wrap = __wrap !== undefined ? __wrap : true;
  let direction = __direction !== undefined ? __direction : "ltr";
  let opacity = __opacity !== undefined ? __opacity : 1;
  let match = Stylex.props(lineHeightFromParams(props.lineHeight, size), baseStyleFromParams(variation, underlined, strikethrough, italic, props.maxLines, wrap, direction), alignFromParams(align), weightFromParams(weight), {
    fontSize: FontSizes.toPx(size),
    opacity: opacity
  });
  return JsxRuntime.jsx("span", {
    children: props.children,
    className: match.className,
    style: match.style
  });
}
let make = React.memo(TextStyle);
export { make };
/* styles Not a pure module */